export default __webpack_public_path__ + "static/trust-a8af45246e2629b1d0e5db17e2eafca0.png";